import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { OCCUPATION_LIST, OCCUPATION_ADDEDIT, OCCUPATION_CHANGE_STATUS, OCCUPATION_DELETE } from "../../api/constApi";
import { occupationListApi, occupationChangeStatusApi, AddEditOccupationApi, occupationDeleteApi } from "../Services/occupationService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const occupationList = createAsyncThunk(OCCUPATION_LIST, async (payload) => {
    const response = await occupationListApi(payload);
    return response.data;
});

export const occupationChangeStatus = createAsyncThunk(OCCUPATION_CHANGE_STATUS, async (payload) => {
    const response = await occupationChangeStatusApi(payload);
    return response.data;
});

export const addEditOccupation = createAsyncThunk(OCCUPATION_ADDEDIT, async (payload) => {
    const response = await AddEditOccupationApi(payload);
    return response.data;
});

export const deleteOccupation = createAsyncThunk(OCCUPATION_DELETE, async (payload) => {
    const response = await occupationDeleteApi(payload);
    return response.data;
});



export const occupationSlice = createSlice({
    name: "occupation",
    initialState: {
        occupation: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(occupationList.fulfilled, (state, action) => {
            state.occupation = action?.payload;
        });
        builder.addCase(addEditOccupation.fulfilled, (state, action) => {
            state.occupation = action?.payload?.Data;
          });
    }
});

export default occupationSlice.reducer;

// villagelist selector
export const selectOccupationList = (state) => state?.occupation?.occupation;
export const useOccupationList = () => {
  const occupation = useSelector(selectOccupationList);
  return useMemo(() => occupation, [occupation]);
};